import React from "react";
import ProgressCard from "./ProgressCard";
import UserProgress from "../../classes/UserProgress";
import AchivementListCard from "./AchivementListCard";
import AchivementListCardDemo from "./AchievementListCardDemo";
import { QURAN_SURAH } from "../../classes/UserProgress";

interface ProgressListViewProps {
  userProgress: UserProgress[];
  persentageValue: number;
  versesCompleted: number;
}

const surahName = (chapter: number) => {
  return QURAN_SURAH.find((surah) => surah.number === chapter)?.name;
};

const getUserProgressForCard = (userProgress: UserProgress) => {
  return {
    progressFrom: `Surah ${surahName(userProgress.progressFrom.chapter)} (${
      userProgress.progressFrom.chapter
    }:${userProgress.progressFrom.verse})`,
    progressTo: `Surah ${surahName(userProgress.progressTo.chapter)} (${
      userProgress.progressTo.chapter
    }:${userProgress.progressTo.verse})`,
    buttonLink: "/new-progress/" + userProgress.id,
  };
};

const ProgressListView: React.FC<ProgressListViewProps> = ({
  userProgress,
  persentageValue,
  versesCompleted,
}) => {
  const getUserProgressTier = () => {
    return {
      name: "Bronze",
      level: "1",
    };
  };

  return (
    <>
      <div className="w-full flex flex-col justify-center items-center my-8">
        <h2 className="font-grgrifter text-[2.2rem] tracking-wider text-[#AFAEB3] mb-4">
          Your Progress
        </h2>
        <div className=" w-full flex flex-col gap-4 my-2">
          {userProgress.length === 0 ? (
            <ProgressCard
              cardConfig={{
                progressFrom: "No progress to show",
                progressTo: "",
                buttonLink: "/new-progress",
              }}
            />
          ) : (
            // <p>No progress to show</p>
            <>
              <ProgressCard
                cardConfig={getUserProgressForCard(userProgress[0])}
              />
              <AchivementListCard versesCompleted={versesCompleted} />
              {/* <AchivementListCard tier={getUserProgressTier()} /> */}
            </>
          )}
        </div>
      </div>
    </>
  );
};

export default ProgressListView;
